import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { FormsService } from '../../../shared/forms.service';
import { HttpService } from '../../../shared/http.service';
import { AlertService } from '../../../shared/alert.service';
import { InitjsService } from '../../../shared/initjs.service';
import { ConsultationResponse, ConsultationRequest } from '@builtbybros/al-model';
import moment = require('moment');

@Component({
  selector: 'app-consultation-form',
  templateUrl: './consultation-form.component.html',
  styleUrls: ['./consultation-form.component.scss']
})
export class ConsultationFormComponent implements OnInit {

  consultationId: number;
  url = '/Consultation/';
  consultationForm: FormGroup;
  consultationData: ConsultationResponse.Consultation;
  status: string;
  consultationLoaded = false;
  category: number;
  msg = {
    'update': 'Reserva actualizada correctamente'
  };
  states = [
    ['Pendiente', 'Pendiente'],
    ['Resuelto', 'Resuelto']
  ];

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private formsService: FormsService,
    private httpService: HttpService,
    private initJsService: InitjsService,
    private alertService: AlertService
  ) {
    this.createFormGroup();
  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      if (params['consultationId']) {
        this.consultationId = +params['consultationId'];
        const responseExpected = new ConsultationResponse.Consultation();
        this.httpService.get(this.url, this.consultationId, responseExpected)
          .subscribe(
            consultationResponse => {
              this.consultationData = consultationResponse;
              this.consultationLoaded = true;
              this.consultationForm.patchValue(consultationResponse);
              this.consultationForm.patchValue({'updatedAt': moment(consultationResponse['updatedAt']).format('DD/MM/YYYY HH:mm')});
              this.consultationForm.get('phone').disable();
              this.consultationForm.get('email').disable();
              this.consultationForm.get('description').disable();
              this.consultationForm.get('updatedAt').disable();
              this.status = consultationResponse.status;
            },
            error => {
              this.alertService.error(error);
            }
          );
      }
    });
    this.initJsService.initJs();
  }

  setStatus(value) {
    this.status = value;
  }

  submitForm() {
    if (this.formsService.validateFormAndUpdateErrors(this.consultationForm)) {
      const consultation = new ConsultationRequest.Update();
      consultation.status = this.status;
      consultation.observations = this.consultationForm.get('observations').value;
      const responseExpected = new ConsultationResponse.Consultation();
      this.httpService.patch(this.consultationId, '/Consultation/', consultation, responseExpected)
        .subscribe(
          reservationResponse => {
            this.alertService.success(this.msg['update']);
          },
          error => {
            this.alertService.error(error);
          }
        );
    }
  }

  private createFormGroup() {
    this.consultationForm = this.fb.group({
      'phone': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'email': [
        null,
        Validators.compose([
          Validators.required,
          Validators.email
        ])
      ],
      'description': [
        null,
        Validators.compose([
          Validators.required
        ])
      ],
      'updatedAt': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'status': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'observations': [
        null,
        Validators.compose([
          Validators.maxLength(100)
        ])
      ]
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/consultation/shared/consultation-form/consultation-form.component.ts